import CONFIGURACIONES from "../../../../util/constants";
import OWASP from "../../../../util/owasp";
import WaveButton from "../../../global/WaveButton";

import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";

import { Http } from "../../../../helpers/Http";
import { useLocation, useOutletContext } from "react-router-dom";

const MantCaja = ({mant, idEdit, createData, updateData, closeSection, idRef, setIdRef, endPointShow, setEndPointUpdate, showCreate, showEdit, init, seriesAsignadas}) => {
    const location = useLocation();
    const { showSpinnerLoader } = useOutletContext();

    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm({mode: "onChange"});
    const [title, setTitle] = useState(CONFIGURACIONES.INIT.STRING);

    useEffect(() => {
        reset();
        showSpinnerLoader();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        console.log('lastSeg', lastSegment);
        
        if (lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')) {
            init();
            setIdRef((lastSegment === 'new'? CONFIGURACIONES.INIT.ID_EDIT:lastSegment));
            showData((lastSegment === 'new'? CONFIGURACIONES.INIT.ID_EDIT:lastSegment));
            setTitle((lastSegment === 'new')? `Creando ${mant}`:`Editando ${mant}`);
        }
        
    }, [location.pathname]);

    const onSubmit1 = (form) => {
        // console.log('form', form);
        if (idRef === CONFIGURACIONES.INIT.ID_EDIT) {
            createData(form);
        } else {
            updateData(form);
        }
    };

    const showData = async (ref) => {
        console.log('ref', ref);
        
        if (ref !== CONFIGURACIONES.INIT.ID_EDIT) {
            console.log('entras...', endPointShow);
            if (endPointShow === CONFIGURACIONES.INIT.STRING || !showEdit) { closeSection(); }
            
            await Http().get(endPointShow)
            .then(async (rpta) => {
                if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                    // setLinks(rpta.data.links);
                    setEndPointUpdate(rpta.data.links.find(link => link.rel === CONFIGURACIONES.REFS.UPDATE)?.href || null);
                    // let cmpLink = rpta.data.links.find(link => link.rel === CONFIGURACIONES.INIT.HREF_LOGS);
                    // console.log('cmpLink', cmpLink);
                    // await loadLogData(cmpLink?.href);
                    loadForm(rpta.data);
                }
            });
        } else {
            if (!showCreate) { closeSection(); }
        }
    };

    const loadForm = (object) => {
        setValue('tipoCaja', object.tipoCajaNombre);
        setValue('nombre', object.nombre);
        setValue('soloEfectivo', object.soloEfectivo == CONFIGURACIONES.INIT.STRING_SI?CONFIGURACIONES.INIT.STATUS_TRUE:CONFIGURACIONES.INIT.STATUS_FALSE);
        setValue('serieAsignada', object.serieAsignada);
    };

    return (
        <>
        { idEdit >= CONFIGURACIONES.INIT.NUMBER && <>
            {/* <h5 className="card-title font-weight-bold">Editando Empleado</h5> */}
            <div className="card-content">
                <form action="" className="form" onSubmit={handleSubmit(onSubmit1)} autoComplete="off">
                    <div className="row">
                        <div className="col-xs-12 col-md-11"> 
                            <h5 className="card-title font-weight-bold">{title}</h5>
                            <div className="row">
                                <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="tipoCaja" className="control-label col-form-label">Tipo de Caja <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("tipoCaja", {
                                                required: OWASP.REQUIRED,
                                            })} className="form-control" id="tipoCaja" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                            {
                                                CONFIGURACIONES.INIT.LIST.TIPOS_CAJA.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.tipoCaja && errors.tipoCaja.message }</small>           
                                    </div>
                                </div>
                                
                                <div className="col-sm-12 col-md-5">
                                    <div className="form-group">
                                        <label htmlFor="nombre" className="control-label col-form-label">Nombre <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("nombre", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.GENERAL,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="text" className="form-control" id="nombre" placeholder="" />
                                        <small className="invalid-feedback"> { errors.nombre && errors.nombre.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="serieAsignada" className="control-label col-form-label">Serie Asignada <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("serieAsignada", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })} className="form-control" id="serieAsignada" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                            {
                                                seriesAsignadas.map((el, index) => (
                                                    <option key={index} value={el.serie}>{el.serie} [{el.tiposDocumento}]</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.serieAsignada && errors.serieAsignada.message }</small>           
                                    </div>
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md-3">
                                    <div className="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" id="chkSoloEfectivo" {...register('soloEfectivo')} />
                                        <label className="custom-control-label" htmlFor="chkSoloEfectivo">Sólo Efectivo</label>
                                    </div>
                                    <small className="invalid-feedback"> { errors.soloEfectivo && errors.soloEfectivo.message }</small>           
                                </div>
                            </div>
                        </div>
                    </div>
                       
                    <div className="action-form mt-1 d-flex justify-content-start">
                        <div className="form-group mb-0 text-left">
                            <WaveButton type="button" onClick={ closeSection } className="btn btn-sm btn-outline-danger waves-effect">
                                <i className="mdi mdi-arrow-left"></i> Descartar
                            </WaveButton>
                            { idRef == CONFIGURACIONES.INIT.ID_EDIT && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Guardar
                            </WaveButton>}

                            { idRef > CONFIGURACIONES.INIT.NUMBER && <WaveButton type="submit" className="btn btn-sm btn-info waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Modificar
                            </WaveButton>}
                        </div>
                    </div>
                </form>
            </div>
            </>
        }
        </>
    )
}
export default MantCaja;